import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getTerms : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.get('admin/terms', {}).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	editTerms : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.patch('admin/terms', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/TermsModule.js